import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { TranslationOptionsParams } from 'src/shared/shared.types';

export type E03EventConfirmationProps = {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams & E03EventConfirmationParams;
};

export type E03EventConfirmationParams = ComponentParams & TranslationOptionsParams;
